module.exports = __webpack_public_path__ + "static/media/demodaywithpresident.de4a82cf.jpeg";